module.exports = __webpack_public_path__ + "img/1.b28cb539.jpg";